import { StatusGraphNode } from '@models';

export interface StatusGraphState {
  statusGraph: StatusGraphNode[];
  loading: boolean;
}

export const STATUS_GRAPH_SLICE = 'statusGraph';
